import React from 'react';
import './Spinner.scss';

const Spinner = () =>
    <div className="snippetload-overlay-wrapper">
      <div className="spinner"></div>
    </div>;
	
export default Spinner;